export default __webpack_public_path__ + "static/cta-trainer-1-13883f38e7c36737c51b19ba5cee1475.jpg";